(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function () {
    function initTextReadMore(root) {
      root.querySelectorAll('.text-block--collapsible').forEach(function (block) {
        // The toggle is rendered right after the text element (see the comment
        // in the markup above), with the in-child lookup kept as a fallback for
        // any cached/older markup.
        const next = block.nextElementSibling;
        const button =
          next && next.classList.contains('text-block__read-more-button')
            ? next
            : block.querySelector('.text-block__read-more-button');
        const label = button && button.querySelector('.text-block__read-more-text');
        if (!button || !label) return;
        if (button.dataset.readMoreBound) return;
        button.dataset.readMoreBound = 'true';

        const showMoreText = block.dataset.showMoreText || 'Show more';
        const showLessText = block.dataset.showLessText || 'Show less';

        button.addEventListener('click', function () {
          const expanded = block.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          label.textContent = expanded ? showLessText : showMoreText;
        });
      });
    }

    // No-op when the page has no collapsible text blocks (querySelectorAll
    // just returns an empty list) — kept unconditional since this tag type
    // cannot be wrapped in a Liquid conditional in Shopify themes.
    initTextReadMore(document);
    document.addEventListener('shopify:section:load', function (event) {
      initTextReadMore(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
